export default function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/size.js
// module id = null
// module chunks = 